import React from 'react';
import { ArrowRight, Calendar, ExternalLinkIcon } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { motion } from 'framer-motion';
export function BlogSection() {
  const {
    t
  } = useLanguage();
  const posts = [{
    title: 'Singderm® ฟิลเลอร์มาตรฐานสากล',
    excerpt: 'ที่คลินิกความงามในกว่า 30 ประเทศเลือกใช้ พร้อมการรับรอง CE พัฒนาด้วยแนวคิด "สมดุล + เป็นธรรมชาติ" เพื่อผลลัพธ์ที่ดูละมุน กลมกลืน และเหมาะกับแต่ละบุคคล',
    date: 'Apr 2026',
    category: 'Product',
    image: 'https://cdn.magicpatterns.com/uploads/jU15M6aXqf4Cuk3eNYUHv2/673859259_122183901410942182_7217029902322325613_n.jpg',
    link: 'https://www.facebook.com/share/p/1JGMB3zbRP/'
  }, {
    title: 'ตอบโจทย์ทั้งการเติมเต็ม ปรับรูปหน้า และยกกระชับ',
    excerpt: 'ด้วยคุณภาพระดับ Medical Grade ที่มืออาชีพไว้วางใจ เพราะผลลัพธ์ที่ลงตัว…เริ่มต้นจากสิ่งที่คุณเลือกใช้ ENDLESS PURSUIT FOR BEAUTY',
    date: 'Apr 2026',
    category: 'Clinical Practice',
    image: null,
    link: 'https://www.facebook.com/share/p/1B4mJdSXLc/'
  }, {
    title: 'Pola Group - ผู้นำเข้าและจัดจำหน่ายอย่างเป็นทางการ',
    excerpt: 'สอบถามรายละเอียด / สั่งซื้อ Singderm® ฟิลเลอร์คุณภาพระดับสากล ติดต่อ 065-242-5494 หรือผ่าน Line Official',
    date: 'Apr 2026',
    category: 'Company News',
    image: null,
    link: 'https://www.facebook.com/share/p/1AeP27KCYY/'
  }, {
    title: 'Singderm Universal Filler - ฟิลเลอร์ HA เทคโนโลยี DVS',
    excerpt: 'ฟิลเลอร์ Hyaluronic Acid พัฒนาเทคโนโลยี DVS Cross-linking เนื้อเจลมีความเสถียร ควบคุมการดูดซึมน้ำ คงรูปตามปริมาณที่ใช้ ผ่านมาตรฐาน CE ผลลัพธ์ประมาณ 12 เดือน',
    date: 'Apr 2026',
    category: 'Product',
    image: 'https://cdn.magicpatterns.com/uploads/d23XNiUqoMbaBqqWTTewdT/674274399_122183263802942182_5891749208808200484_n.jpg',
    link: 'https://www.facebook.com/share/p/1JGMB3zbRP/'
  }];
  return <section id="blog" className="py-24 bg-brand-bg" data-id="element-67">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-68">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16" data-id="element-69">
          <div className="max-w-2xl" data-id="element-70">
            <h2 className="text-sm font-bold tracking-widest text-brand-copper uppercase mb-3" data-id="element-71">
              {t('blog.label')}
            </h2>
            <h3 className="text-3xl md:text-4xl font-light text-gray-900" data-id="element-72">
              {t('blog.title1')}{' '}
              <span className="font-semibold" data-id="element-73">{t('blog.title2')}</span>
            </h3>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-74">
          {posts.map((post, index) => <motion.article key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow flex flex-col h-full" data-id="element-75">
              <div className="aspect-[16/9] bg-gray-100 relative overflow-hidden" data-id="element-76">
                {post.image ? <img src={post.image} alt={post.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" data-id="element-77" /> : <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-brand-copper/10 to-brand-lightCopper/20" data-id="element-78">
                    <span className="text-brand-copper font-semibold text-lg tracking-wide" data-id="element-79">
                      Singderm®
                    </span>
                  </div>}
                <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded text-xs font-semibold text-brand-copper" data-id="element-80">
                  {post.category}
                </div>
              </div>
              <div className="p-6 flex flex-col flex-grow" data-id="element-81">
                <div className="flex items-center text-gray-400 text-xs mb-3" data-id="element-82">
                  <Calendar size={14} className="mr-1.5" data-id="element-83" />
                  {post.date}
                </div>
                <h4 className="text-xl font-semibold text-gray-900 mb-3 line-clamp-2" data-id="element-84">
                  {post.title}
                </h4>
                <p className="text-gray-600 text-sm mb-6 line-clamp-3 flex-grow" data-id="element-85">
                  {post.excerpt}
                </p>
                <a href={post.link} target="_blank" rel="noopener noreferrer" className="text-brand-copper font-medium text-sm flex items-center hover:text-brand-darkCopper transition-colors mt-auto w-fit" data-id="element-86">
                  {t('blog.readMore')}{' '}
                  <ExternalLinkIcon size={14} className="ml-1.5" data-id="element-87" />
                </a>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}